import {
  COLOR_POPUP_BG_DEFAULT,
  COLOR_POPUP_TEXT_DEFAULT,
} from '@containers/Home/constants';
import { FlexColStart } from '@styles/global-styles';
import styled, { css } from 'styled-components';

export const DialogPostWrapper = styled.div<{
  isUseDefaultStyle?: boolean;
  isUseDefaultColor?: boolean;
}>`
  ${props => !props.isUseDefaultStyle && css``}
  background: ${props =>
    props.isUseDefaultColor ? COLOR_POPUP_BG_DEFAULT : 'var(--color-popup-bg)'};
  color: ${props =>
    props.isUseDefaultColor
      ? COLOR_POPUP_TEXT_DEFAULT
      : 'var(--color-popup-text)'};
  height: max-content;
  max-height: 95vh;
  overflow: auto;
  width: 100%;
  padding: 0;
  border-radius: 12px;
  ${FlexColStart};
  .header {
    position: relative;
    border-bottom: 1px solid rgb(255 255 255 / 0.2);
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .thumb {
      width: max-content;
      max-width: 100%;
      height: auto;
    }
    .title {
      font-weight: 600;
      width: 100%;
      position: relative;
      font-size: 1rem;
      text-transform: uppercase;
      text-align: center;
      padding: 1.5rem 3rem;
      background: rgba(0, 0, 0, 0.1);
    }
    &:after {
      content: '';
      width: 64px;
      height: 2px;
      background: ${props =>
        props.isUseDefaultColor
          ? COLOR_POPUP_TEXT_DEFAULT
          : 'var(--color-popup-text)'};
      display: block;
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .body {
    width: 100%;
    height: 100%;
    padding: 1.5rem 3rem;
    margin: 0 auto;
    height: auto;
    .content {
      width: 100%;
      min-height: 200px;
    }
  }
  @media (max-width: 575px) {
    .header {
      .title {
      }
    }
    .body {
      padding: 1.5rem 1rem;
    }
  }
  &.popupIntro {
    transition: var(--transition-regular);
    &.type-article {
      &.mode-fullScreen {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        max-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100000;
        background-color: rgba(0, 0, 0, 0.7);
      }
    }
    .close {
      width: 2.5rem;
      height: 2.5rem;
      position: fixed;
      opacity: 1;
      transition: all 0.15s ease-out;
      z-index: 3;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      /* background: #fff; */
      border-radius: 50%;
      font-size: 24px;
      top: 4px;
      right: 4px;
      /* box-shadow: 0 2px 16px rgb(0 0 0 / 50%); */
      color: #fff;
      i {
        line-height: initial;
      }
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          transform: rotate(90deg);
        }
      }
    }
    .--contentWrapper {
      color: #fff;
      width: 100%;
      max-width: 840px;
      padding: 1rem;
      overflow: auto;
    }
    .--title {
      font-size: 3rem;
      text-align: center;
    }
    .--content {
    }
    .btn,
    .button {
      cursor: pointer;
      border-radius: 12px;
      background-color: rgba(255, 255, 255, 0.35);
      color: #fff;
      text-decoration: none;
      margin: 0 auto;
      width: max-content;
      display: block;
      transition: var(--transition-regular);
      font-weight: 500;
      cursor: pointer;
      outline: none;
      border: none;
      /* &.size-l { */
      padding: 1rem 3rem;
      font-size: 1.5rem;
      /* } */
      &:hover {
        background-color: var(--color-primary);
        color: var(--color-text);
      }
    }
  }
`;
